module.exports = __webpack_public_path__ + "img/ИФ-1(А)-026.8d92b038.png";